module.exports = __webpack_public_path__ + "static/media/subGoogle1.7c8a31b3.png";